<template>

</template>

<script>
    export default {
        name: "ProductDetail"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ProductDetail.vue